namespace $.$$ {

	$mol_style_define( $shm_dashboard_app, {
		width: '100%',
		minHeight: '100%',

		Settings_screen: {
			maxWidth: '720px',
		},

		Documentation: {
			flex: {
				grow: 1,
			},
		},

		Agent_panel: {
			width: '28rem',
			minWidth: '22rem',
			height: '100%',
			minHeight: 0,
			flex: {
				grow: 0,
				shrink: 0,
			},
		},

		Agent_page: {
			width: '100%',
			minWidth: 0,
			height: '100%',
			minHeight: 0,
			flex: {
				grow: 1,
				shrink: 1,
				basis: 0,
			},
		},

	} )

}
